import type { ScreenType } from '../../../types';

import { getElementGroup } from '../../Engine/useGemMeterStore';
import { NO_CALL_TO_ACTION_FOUND } from '../../../constants/rulesConstants';
import { checkEmptyDataSettings } from '../../Engine/useGemMeterHelper';

export default class NoCallToActionFoundRule {
  static ruleId = NO_CALL_TO_ACTION_FOUND.id;

  static validate(screenType: ScreenType, removeElementId?: string) {
    const elementGroups = getElementGroup() || {};
    const elementGroupByRuleId = elementGroups[screenType][NO_CALL_TO_ACTION_FOUND.id] || {};
    const isPageEmpty = checkEmptyDataSettings(removeElementId);

    return Object.keys(elementGroupByRuleId).length > 0 || isPageEmpty;
  }
}
